import { render, staticRenderFns } from "./profession_list.vue?vue&type=template&id=1111aed8&scoped=true&"
import script from "./profession_list.vue?vue&type=script&lang=js&"
export * from "./profession_list.vue?vue&type=script&lang=js&"
import style0 from "./profession_list.vue?vue&type=style&index=0&id=1111aed8&lang=less&scoped=true&"
import style1 from "./profession_list.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1111aed8",
  null
  
)

export default component.exports